import CryptoJS from 'crypto-js'

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY as string

function toBase64Url(base64: string): string {
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

function fromBase64Url(base64url: string): string {
  const padded = base64url.padEnd(base64url.length + ((4 - (base64url.length % 4)) % 4), '=')
  return padded.replace(/-/g, '+').replace(/_/g, '/')
}

export function encryptId(id: string): string {
  const encrypted = CryptoJS.AES.encrypt(id, SECRET_KEY).toString()
  return toBase64Url(encrypted)
}

export function decryptId(encryptedId: string): string {
  const base64 = fromBase64Url(encryptedId)
  const bytes = CryptoJS.AES.decrypt(base64, SECRET_KEY)
  return bytes.toString(CryptoJS.enc.Utf8)
}
